export default "__VITE_ASSET__BltCUkvO__"